import { ReactElement } from 'react';
import isEmpty from 'lodash.isempty';
import { SliceQuoteView } from '@utmb/types/index';
import styles from './quote.module.scss';
import { Slice } from '@utmb/types/slice-handler';
import { Font } from '@utmb/design-system/text/font';
import { Image } from '@utmb/design-system/image/Image';

export const Quote = (props: Slice<SliceQuoteView>): ReactElement | null => {
    const { id, content, author, authorTitle, picture } = props;

    if (isEmpty(content)) return null;

    return (
        <div>
            <blockquote id={id} className={styles.quote} dangerouslySetInnerHTML={{ __html: content }} />
            {author && (
                <div className={styles.authorWithPicture}>
                    <div className={styles.author}>
                        <Font.FuturaBold desktop="20" mobile="16">
                            {author}
                        </Font.FuturaBold>
                        <Font.FuturaBook desktop="16" mobile="12">
                            {authorTitle}
                        </Font.FuturaBook>
                    </div>

                    {picture && (
                        <div className={styles.picture}>
                            <Image image={picture} className={styles.authorPicture} objectFit={'cover'} layout={'fill'} />
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};
